import update from 'immutability-helper';
import trim from 'ramda/src/trim';

import ActionTypes from 'constants/ActionTypes';
import ComparingBoxViews from 'constants/ComparingBoxViews';
import { HTTPS } from 'constants/Protocols';

const initialState = {
    currentView: ComparingBoxViews.VIEW_FORM,
    deltaY: 0,
    scrollLeft: 0,
    url: '',
    urlProtocol: HTTPS,
};

const comparingBoxReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.UI_COMPARING_BOX_CURRENT_VIEW_SET: {
            return update(state, {
                currentView: { $set: action.payload },
            });
        }
        case ActionTypes.UI_COMPARING_BOX_DELTA_Y_SET: {
            return update(state, {
                deltaY: { $set: action.payload },
            });
        }
        case ActionTypes.UI_COMPARING_BOX_SCROLL_LEFT_SET: {
            return update(state, {
                scrollLeft: { $set: action.payload },
            });
        }
        case ActionTypes.UI_COMPARING_BOX_URL_SET: {
            const url = trim(action.payload);
            const withoutProtocolUrl = url.replace(/^https?:\/\//g, '');

            return update(state, {
                url: { $set: withoutProtocolUrl },
            });
        }
        case ActionTypes.UI_COMPARING_BOX_URL_PROTOCOL_SET: {
            return update(state, {
                urlProtocol: { $set: action.payload },
            });
        }
        default: {
            return state;
        }
    }
};

export default comparingBoxReducer;
